export default __webpack_public_path__ + "static/test_1_1_ru-942b37e641c0239753fd84c443c302ad.png";